function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9506 193.545L78.0163 170.282H46.7286L60.8074 193.545H62.379H63.9506Z",
  fill: "#9FCEF8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.8504 166.229L61.9074 165.714C61.2264 165.345 45.1046 156.393 30.1221 137.052C16.279 119.176 1.00843 88.732 6.86259 45.2834L7.11143 43.4087H118.157L118.603 44.9138C118.825 45.6531 123.959 63.4365 119.794 87.3326C115.957 109.327 103.122 140.775 63.7672 165.635L62.8504 166.229ZM10.5558 47.7918C6.56138 80.5334 14.1181 109.552 33.0426 134.055C45.4975 150.188 59.131 159.034 62.7456 161.225C92.2391 142.307 110.601 116.562 115.865 86.7121C119.218 67.7404 116.324 52.4918 115.224 47.7786H10.5558V47.7918Z",
  fill: "#9FCEF8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M78.0163 70.6318V135.6C78.0163 150.651 78.0163 166.216 78.0163 166.216H46.7416C46.7416 166.216 46.7416 150.651 46.7416 135.6V70.6318C46.7416 55.5813 44.8426 49.4026 35.8584 38.1543V37.7847H88.9125V38.1543C79.9152 49.4026 78.0163 55.5813 78.0163 70.6318Z",
  fill: "#9FCEF8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M62.379 33.7713C71.6301 33.7713 79.1295 26.2113 79.1295 16.8857C79.1295 7.55997 71.6301 0 62.379 0C53.1279 0 45.6284 7.55997 45.6284 16.8857C45.6284 26.2113 53.1279 33.7713 62.379 33.7713Z",
  fill: "#9FCEF8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.36864 54.6439C12.9906 54.6439 16.7374 50.8669 16.7374 46.2077C16.7374 41.5485 12.9906 37.7715 8.36864 37.7715C3.74674 37.7715 0 41.5485 0 46.2077C0 50.8669 3.74674 54.6439 8.36864 54.6439Z",
  fill: "#9FCEF8"
});

function SvgBlueBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 183,
    viewBox: "0 0 97 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBrandIcon);
export default __webpack_public_path__ + "static/media/blue-brand-icon.54985a51.svg";
export { ForwardRef as ReactComponent };